module.exports = __webpack_public_path__ + "media/images/lps-sell_housing-5a9f2fc3.png";